import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  ogImage, 
  canonicalUrl,
  robots 
}) => {
  const siteTitle = 'Smart F & B';
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;

  return React.createElement(
    Helmet,
    null,
    React.createElement('title', null, fullTitle),
    React.createElement('meta', { name: 'description', content: description || 'Smart F & B - Restaurant Management' }),
    React.createElement('meta', { name: 'keywords', content: keywords || 'restaurant, food, delivery, catering' }),
    React.createElement('meta', { name: 'robots', content: robots || 'index, follow' }),
    
    // Open Graph
    React.createElement('meta', { property: 'og:title', content: fullTitle }),
    React.createElement('meta', { property: 'og:description', content: description || 'Smart F & B - Restaurant Management' }),
    ogImage && React.createElement('meta', { property: 'og:image', content: ogImage }),
    React.createElement('meta', { property: 'og:type', content: 'website' }),
    React.createElement('meta', { property: 'og:url', content: typeof window !== 'undefined' ? window.location.href : '' }),
    
    // Twitter
    React.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
    React.createElement('meta', { name: 'twitter:title', content: fullTitle }),
    React.createElement('meta', { name: 'twitter:description', content: description || 'Smart F & B - Restaurant Management' }),
    
    // Canonical
    canonicalUrl && React.createElement('link', { rel: 'canonical', href: canonicalUrl })
  );
};

export default SEO;